import React from "react";
import { object } from "prop-types";

import DfpContainer from "../../../ads/dfp-container";
import { DfpComponent } from "../../../ads/dfp-component";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import WidgetPlaceholder from "../WidgetPlaceholder";
import NewsWithImage from "../../../molecules/NewsWithImage";
import SpecialEvent from "../SpecialEvent";

import { useDeviceType } from "../../../utils/react-utils";
import { getSlotId, getStoriesFromCollection, trim } from "../../../utils/utils";

import "./mobile-layout.m.css";

const MobileLayout = ({ collection }) => {
  const { mobile } = useDeviceType();
  let {
    "associated-metadata": {
      widget_80_url: widget80,
      widget_100_url: widget100,
      widget_250_url: widget250,
      ad_slot_1: adSlot1,
      ad_slot_2: adSlot2,
    } = {},
  } = collection;

  const stories = getStoriesFromCollection(collection, 20);

  widget80 = trim(widget80);
  widget100 = trim(widget100);
  widget250 = trim(widget250);

  const bottomWidget = (() => {
    if (widget100) {
      return { height: 100, url: widget100, size: "small" };
    } else if (widget250) {
      return { height: 250, url: widget250, size: "big" };
    } else return null;
  })();

  const [first, second] = stories;
  const thirdFourth = stories.slice(2, 4);
  const fifthSixth = stories.slice(4, 6);
  const seventhToNinth = stories.slice(6, 9);
  const tenthToFifteenth = stories.slice(9, 15);
  const sixteenthToLast = stories.slice(15);

  return (
    <div styleName="container">
      <NewsWithImage styleName="row-item first-story" story={first} showExcerpt={true} widths={[450]} />
      <DfpContainer styleName="r1-ad">
        {mobile && (
          <DfpComponent
            type={adSlot1}
            collectionSlug={collection.slug}
            slotId={getSlotId(adSlot1, collection.slug, 10)}
            layoutName="FourteenStories3Ad1Widget"
          />
        )}
      </DfpContainer>
      <SpecialEvent collection={collection} styleName="special" />
      {second && (
        <LeftImageRightNews story={second} styleName="row-item top-row" showExcerpt={true} widths={[160, 220, 280]} />
      )}
      <WidgetPlaceholder styleName="widget" url={widget80} height={80} />
      {thirdFourth.map((story, index) => (
        <LeftImageRightNews key={index} styleName="row-item top-row" story={story} showExcerpt={true} widths={[220]} />
      ))}
      {fifthSixth.length && (
        <div styleName="column">
          {fifthSixth.map((story, i) => (
            <NewsWithImage
              key={i}
              styleName="column-item"
              story={story}
              imageType="image1x1"
              aspectRatio={[1, 1]}
              widths={[260]}
            />
          ))}
        </div>
      )}
      {seventhToNinth.map((story, i) => (
        <LeftImageRightNews styleName="row-item top-row" key={i} story={story} showExcerpt={true} widths={[220]} />
      ))}
      <DfpContainer styleName="b1-ad">
        {mobile && (
          <DfpComponent
            type={adSlot2}
            collectionSlug={collection.slug}
            slotId={getSlotId(adSlot2, collection.slug, 2)}
            layoutName="FourteenStories3Ad1Widget"
          />
        )}
      </DfpContainer>
      {tenthToFifteenth.length && (
        <div styleName="column">
          {tenthToFifteenth.map((story, i) => (
            <NewsWithImage styleName="column-item" story={story} key={i} widths={[260]} />
          ))}
        </div>
      )}
      <WidgetPlaceholder styleName="big-widget" url={bottomWidget?.url} height={bottomWidget?.height} />
      {sixteenthToLast.map((story, i) => (
        <LeftImageRightNews
          styleName="row-item bottom-row"
          story={story}
          key={i}
          aspectRatio={[1, 1]}
          imageType="image1x1"
          widths={[160]}
        />
      ))}
    </div>
  );
};

MobileLayout.propTypes = {
  collection: object,
};

export default MobileLayout;
